var map = {
	"./1/symbol_0.png": 1359,
	"./1/symbol_1.png": 62342,
	"./1/symbol_10.png": 51668,
	"./1/symbol_11.png": 72797,
	"./1/symbol_12.png": 47910,
	"./1/symbol_13.png": 70575,
	"./1/symbol_2.png": 59901,
	"./1/symbol_3.png": 26868,
	"./1/symbol_4.png": 76779,
	"./1/symbol_5.png": 55650,
	"./1/symbol_6.png": 11737,
	"./1/symbol_7.png": 5488,
	"./1/symbol_8.png": 25399,
	"./1/symbol_9.png": 79822
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94925;